import { render, staticRenderFns } from "./foodlogin.vue?vue&type=template&id=4b417653&scoped=true"
import script from "./foodlogin.vue?vue&type=script&lang=js"
export * from "./foodlogin.vue?vue&type=script&lang=js"
import style0 from "./foodlogin.vue?vue&type=style&index=0&id=4b417653&prod&lang=css"
import style1 from "./foodlogin.vue?vue&type=style&index=1&id=4b417653&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b417653",
  null
  
)

export default component.exports